import React, { Component } from 'react';
import {
	Form,
	// Radio,
	Input,
	Button,
	message
} from 'antd';
import { getCrytoPrice } from '../../common/fetch';

class SelectAmount extends Component {
	state = {
		estimated: 0,
		amount: ''
	};

	currency = {};

	componentDidMount() {
		this.getData();
	}

	getData = async () => {
		try {
			const res = await getCrytoPrice();
			const cryptos = Object.keys(res);
			cryptos.forEach((crypto) => {
				if (crypto.indexOf('usdt') >= 0) {
					const symbol = crypto.split('-')[0];
					this.currency[symbol.toLowerCase()] = res[crypto].last;
				}
			});
		} catch (error) {
			console.error(error);
		}
	};

	calculateCurrency = (e) => {
		const { value } = e.target;
		this.setState(
			{
				amount: value
			},
			() => {
				const { currency } = this.props;
				if (this.currency.hasOwnProperty(currency.toLowerCase())) {
					const amount = parseFloat(value);
					if (!isNaN(amount)) {
						const estimated =
							((amount * this.currency[currency.toLowerCase()]) /
								this.currency['xht']) *
							1.1;
						this.setState({ estimated });
					}
				}
			}
		);
	};

	handleClick = (e) => {
		e.preventDefault();
		const { next } = this.props;
		const { amount } = this.state;
		if (isNaN(parseFloat(amount))) {
			message.warning('Input your charge amount');
			return;
		}
		next('input', amount);
	};

	renderInput = () => {
		const { currency } = this.props;
		return (
			<Form.Item style={{ paddingTop: '12px' }}>
				<Input
					style={{ width: '100%' }}
					addonBefore={currency.toUpperCase()}
					onChange={this.calculateCurrency}
				/>
			</Form.Item>
		);
	};

	render() {
		const { estimated } = this.state;
		return (
			<Form onSubmit={this.handleClick}>
				{this.renderInput()}
				{estimated === 0 ? (
					''
				) : (
					<p>
						<b>Estimated received amount: </b>
						{estimated.toFixed(2)} XHT
					</p>
				)}
				<div className="btn-area">
					<Button block type="primary" onClick={this.handleClick}>
						Next
					</Button>
				</div>
			</Form>
		);
	}
}

const WrappedSelectAmount = Form.create()(SelectAmount);

export default WrappedSelectAmount;
